import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";

export interface PageContactProps {
    className?: string;
}

interface FAQItem {
    section: string;
    question: string;
    answer: React.ReactNode;
}

const services: FAQItem[] = [

    {
        section: "Registration / Login",
        question: "I forgot my Login ID and password. Can you assist me?",
        answer: (
            <>
                <b>Forgot Login ID:</b> Your login id it is same as your mail id that you have used while registering with us.
                <br /><br />
                Incase you have used separate email id to register with us then please refer the mails of that id, as your registration details are mailed to you on the same id used by you to register with us.
                <br /><br />
                <b>Forgot Password:</b> It is not be necessary to remember your password as you can log in with OTP received by you on SMS or you can even log in with OTP received by you on your e-mail id.
                <br /><br />
                Incase you are not sure which email id you have used during registration process; you may contact Vijaydeep Sales Team from Monday to Saturday (10:00 AM to 7:00 PM); Except Public Holidays.
                <br /><br />
                Tel No:- 022-61077909 to 912 or Mob: 9082677909 or Email: sales@vijaydeep.in
            </>
        ),
    },
    {
        section: "Registration / Login",
        question: "I just finished registering on your website, but I can't log in.",
        answer: (
            <>
                After you complete the one-time registration process, Details are forwarded to Vijaydeep Sales Team for verification.
                
                Once the Verification is done by the team, you should receive an e-mail confirmation.
                <br /><br />
                Post receipt of the email confirmation, you will be allowed to Login.
                <br /><br />
                If you have not received e-mail confirmation, kindly check your spam or junk mail.
                
                Or If you face difficulty in registration, For assistance, you may contact Vijaydeep Sales Team Monday to Saturday (10:00 AM to 7:00 PM); Except Public Holidays.
                <br /><br />
                Tel No:- 022-61077909 to 912 or Mob: 9082677909 or Email: sales@vijaydeep.in
            </>
        ),
    },
    {
        section: "Registration / Login",
        question: "How long does it take to open an account with Vijaydeep?",
        answer: (
            <>
                It takes 3 to 4 hours’ time from the time customer has completed the registration process online.
                <br /><br />
                Working Hours are Monday to Saturday (10:00 AM to 7:00PM); Except Public Holidays.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Which catalog’s ordering codes are supported on the website.",
        answer: (
            <>
                All the code mentioned in the Vijayeep’s Catalog Vol: VMA 18/05 are supported on the website.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "We have Vijaydeep’s Catalog, but we are not able to find the ordering code on the website.",
        answer: (
            <>
                Only the code mentioned in the Vijayeep’s Catalog Vol: VMA 18/05 are currently supported on the website.
                
                Alternately you can select the products directly from the website and place the order.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Is it possible to cancel/change the order confirmed online?",
        answer: (
            <>
                It is not possible to cancel the order, however with regards to change, we request you to get in touch with sales Team.
                
                Changes in the order are done solely at discretion of Vijaydeep Sales Team.
                <br /><br />
                Request you to get in touch Vijaydeep Sales Team Monday to Saturday (10:00 AM to 7:00 PM); Except Public Holidays.
                <br /><br />
                Tel No:- 022-61077909 to 912 or Mob: 9082677909 or Email: sales@vijaydeep.in
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "What if there is an error while confirming the order?",
        answer: (
            <>
                If you come across any error during order confirmation process, request you to take the screen shot and share it with the sales team for further investigation.
                
                Sales team will try to resolve the same as soon as possible and contact you with necessary solution.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "How do I locate an order that I have already completed?",
        answer: (
            <>
                All orders are located in Order List.
                
                To see the Order List, click on the profile icon on the top right side of web page and select Order List.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "If I have searched the part numbers and added them to the cart, can I place an order?",
        answer: (
            <>
                Yes. Click on the “Cart” icon and it will present with the list of items that you have added to the cart.
                
                You can remove items which are not suitable and click proceed to checkout.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Where do you enter a Transporter account number, if available?",
        answer: (
            <>
                We do not have a function for entering a <b>Transporter account number. </b> 
                
                You can select “self-arranged” in the select delivery partner section and confirm the order.
                <br /><br />
                Once your order is ready, our sales team will communicate to you to arrange the pickup.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "What payment methods are accepted?",
        answer: (
            <>
                Our Online ordering system gives many payment options like UPI, Credit/Debit Card & Net Banking.
                
                You may select the one suitable to your need.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Can I order an item not listed on website?",
        answer: (
            <>
                If you want product that is not listed on website, you may refer to the customized section,
                select suitable product, enter the details, generate quotation and confirm the order.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "I have a part number from another manufacturer. Can you provide the equivalent?",
        answer: (
            <>
                You may contact Vijaydeep’s Sales team and they will assist you in getting the equivalent.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Will I receive a confirmation after placing my order?",
        answer: (
            <>
                Yes. Once you've placed your order, you will receive a sales order confirmation via e-mail
                and also it displays the sales order no on your screen.
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "I did not get an Order Confirmation for my order. How can I make sure that my order has been processed?",
        answer: (
            <>
                You should receive Order Confirmation by mail as soon as you confirm the order. If you do not get your order confirmation, 
                please contact Vijaydeep Sales Team from Monday to Saturday (10:00AM to 7:00PM); Except Public Holidays.
                <br /><br />
                Tel No:- 022-61077909 to 912 or Mob: 9082677909 or Email: sales@vijaydeep.in
            </>
        ),
    },
    {
        section: "Quotation Generation / Order Confirmation",
        question: "Do I need to send back the confirmation once I have received it?",
        answer: (
            <>
                No. The confirmation is only for your reference purpose.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "Can I change the shipping method once I have placed an order?",
        answer: (
            <>
                To change the shippping method, you can contact our sales team.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "If I place an order on the Website, can I view the tracking number once it's been shipped?",
        answer: (
            <>
                Yes, the tracking details will be made available in your order list once the shipment has been dispatched.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "When can you ship the products?",
        answer: (
            <>
                Kindly refer to the details of your order confirmation on email which indicates the lead time about the product & availability.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "Where are your products dispatched from?",
        answer: (
            <>
                Product are dispatched from Mumbai warehouse.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "How long does it take to deliver the product from your warehouse to our location?",
        answer: (
            <>
                It depends on the shipping method, delivery partner and the delivery location. You may refer to the tracking details available in the order list to track the order.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "How can I get a delivery tracking number for my order?",
        answer: (
            <>
                The tracking details will be made available in your order list once the order has been dispatched.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "How much is the courier/transportation charge?",
        answer: (
            <>
                Courier/transportation charges are calculated based on the total weight of the product and delivery partner that you have selected which is displayed in your shopping cart.
            </>
        ),
    },
    {
        section: "Shipping/ Delivery",
        question: "How should I raise a quality issue?",
        answer: (
            <>
                All our product go to necessary quality checks. However, the transaction is subject to human error. We request you to get in touch with Vijaydeep Sales Team Monday to Saturday (10:00 AM to 7:00 PM); Except Public Holidays.
                <br /><br />
                Tel No:- 022-61077909 to 912 or Mob: 9082677909 or Email: sales@vijaydeep.in
            </>
        ),
    },
    {
        section: "Others",
        question: "What are Vijaydeep office hours?",
        answer: (
            <>
                Monday to Saturday (10:00 AM to 7 PM), Orders received after 6 PM will be processed on next Business Day.
            </>
        ),
    },
    {
        section: "Others",
        question: 'What are the "System Requirements"? / Website not loading properly.',
        answer: (
            <>
                The following web browsers are recommended to view our website:
                <br /><br />
                1. Microsoft Edge
                <br />
                2. Firefox
                <br />
                3. Chrome
                <br />
                4. Safari.
                <br /><br />
                The website may be inoperable or may not display properly if you are using the older version of this web browser.
                Make sure you have the latest version of web browser.
                
                If your IT Team has imposed restriction on certain website, then you may have difficulty in viewing the website.
            </>
        ),
    },
    {
        section: "Others",
        question: "I cannot download the 3D data for a product.",
        answer: (
            <>
                To download the 3D data you need to login to website. 3D files for some product may not be available.  If you need 3D file that is not available on our website, please kindly contact our Sales Team.
            </>
        ),
    },
];

const PageFAQs: FC<PageContactProps> = ({ className = "" }) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
        setActiveIndex(prev => (prev === index ? null : index));
    };

    let lastSection = "";

    return (
        <div
            className={`nc-PageFAQs overflow-hidden ${className}`}
            data-nc-id="PageFAQs"
        >
            <Helmet>
                <title>FAQs | Vijaydeep</title>
            </Helmet>



            {/* FAQ CONTAINER */}
            <div className="container">
                {/* PAGE TITLE */}
                <h2 className="mt-12 mb-12 flex justify-center text-center text-3xl md:text-5xl font-semibold text-neutral-900">
                    Frequently Asked Questions
                </h2>

                <div className="mb-12">
                    {services.map((item, index) => {
                        const showSectionTitle = item.section !== lastSection;
                        lastSection = item.section;

                        return (
                            <React.Fragment key={index}>
                                {/* ✅ SECTION TITLE */}
                                {showSectionTitle && (
                                    <h3 className="mt-10 mb-6 text-xl md:text-2xl font-semibold text-neutral-900">
                                        {item.section}
                                    </h3>
                                )}

                                {/* FAQ ITEM */}
                                <div className="border rounded-md p-4 mb-4">
                                    {/* QUESTION */}
                                    <button
                                        type="button"
                                        onClick={() => toggleAccordion(index)}
                                        className="w-full flex justify-between items-center text-left"
                                    >
                                        <span className="text-base md:text-xl font-medium text-neutral-900">
                                            {item.question}
                                        </span>

                                        <div className="flex-none">
                                            <span className="ml-4 flex h-8 w-8 items-center justify-center rounded-full border">
                                                {activeIndex === index ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-5 h-5 text-neutral-800"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="m4.5 15.75 7.5-7.5 7.5 7.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-5 h-5 text-neutral-800"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="m19.5 8.25-7.5 7.5-7.5-7.5"
                                                        />
                                                    </svg>
                                                )}
                                            </span>
                                        </div>
                                    </button>

                                    {/* ANSWER */}
                                    {activeIndex === index && (
                                        <div className="mt-4 text-sm md:text-base text-neutral-600 leading-relaxed border-t mb-3 pt-4">
                                            {item.answer}
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PageFAQs;